import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell, FGridPercentCell } from '../grid';
import { AxisSummary } from './activityprogramme.models';

export default class ProgrammeAxisGrid extends React.PureComponent<{ rows: AxisSummary[]; loading?: boolean }> {
  private columns: GridColDef[] = [
    { field: 'axiscode', headerName: 'Axis', width: 140 },
    { field: 'axisname', headerName: 'Domaine', flex: 1, minWidth: 280 },
    { field: 'activities', headerName: 'Activities', width: 120, type: 'number' },
    { field: 'completeactivities', headerName: 'Complete', width: 120, type: 'number' },
    { field: 'incompleteactivities', headerName: 'Incomplete', width: 130, type: 'number' },
    { field: 'plannedamount', headerName: 'Planned Amount', width: 160, renderCell: FGridMoneyCell },
    { field: 'revisedamount', headerName: 'Revised Amount', width: 160, renderCell: FGridMoneyCell },
    { field: 'variancepercent', headerName: 'Variance %', width: 130, renderCell: FGridPercentCell },
    { field: 'share', headerName: 'Share', width: 110, renderCell: FGridPercentCell },
  ];

  render() {
    return (
      <FDataGrid
        title="Programme Summary by Axis"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={420}
        getRowId={(row: AxisSummary) => row.id}
        showQuickFilter
        pageSizeOptions={[10, 20, 50]}
      />
    );
  }
}
